import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderExperienceCenter from "../Components/Experience Center/headerExperienceCenter";
import ListExperienceCenter from "../Components/Experience Center/listExperienceCenter";
import ListUserRequest from "../Components/Experience Center/listUserRequest";
import AddExperienceCenter from "../Components/Experience Center/addExperienceCenter";
import ViewExperienceCenter from "../Components/Experience Center/viewExperienceCenter";
import ViewExperienceCenterForm from "../Components/Experience Center/viewUserRequest";
import EditExperienceCenter from "../Components/Experience Center/editExperienceCenter";

const ExperienceCenterRoutes = () => {

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route
        path="/experience_center"
        element={<HeaderExperienceCenter />}
      />
      <Route
        path="/experience_center_list"
        element={<ListExperienceCenter />}
      />
      <Route
        path="/experience_center_user_list"
        element={<ListUserRequest />}
      />
      <Route
        path="/experience_center/add"
        element={canAdd ? <AddExperienceCenter /> : <Navigate to="/experience_center" replace />}
      />
      <Route
        path="/experience_center/view/:id"
        element={<ViewExperienceCenter />}
      />
      <Route
        path="/experience_center_form/view/:id"
        element={<ViewExperienceCenterForm />}
      />
      <Route
        path="/experience_center/edit/:id"
        element={canEdit ? <EditExperienceCenter /> : <Navigate to="/experience_center" replace />}
      />
    </Routes>
  );
};

export default ExperienceCenterRoutes;